export default {
    nav: '導航',
    phone: '手機號',
    email: '郵箱',
    transPwd: '交易密碼',
    logout: '退出登錄',
    confirmLogout: '確定退出登錄？',
    logoutTips: '退出後，下次打開需重新登錄賬號',
    noSaveRecord: '此操作將不會保存您當前記錄',
    confirm: '確定',

    phoneConsult: '電話諮詢',
    onlineService: '聯繫客服',
    WeChatService: '企微客服',

    assets: '資產',
    assetsHome: '資產首頁',
    deposit: '存入資金',
    withdraw: '提取資金',
    currencyExchange: '貨幣兌換',
    orderRecords: '訂單記錄',
    finance: '理財',
    financeHome: '理財首頁',
    cashbox: '星財寶',
    publicFund: '公募基金',
    bill: '票據',
    bond: '債券',

    // contact組件
    contact: '聯繫我們',
    understood: '已了解',
    mainlandService: '內地客服',
    hongKongService: '香港客服',
}
